import React from 'react';
import { observer } from 'mobx-react-lite';
import { SectionTab } from 'polotno/side-panel';
import { ImagesGrid } from 'polotno/side-panel/images-grid';
import { nanoid } from 'nanoid';

export const TemplatesPanel = observer(({ store }) => {
  const items = [
    {
      json: process.env.PUBLIC_URL + '/templates/template1.json',
      preview: process.env.PUBLIC_URL + '/templates/template1.jpeg',
    },
    {
      json: process.env.PUBLIC_URL + '/templates/template2.json',
      preview: process.env.PUBLIC_URL + '/templates/template2.jpeg',
    },
    {
      json: process.env.PUBLIC_URL + '/templates/template3.json',
      preview: process.env.PUBLIC_URL + '/templates/template3.jpeg',
    },
    {
      json: process.env.PUBLIC_URL + '/templates/template4.json',
      preview: process.env.PUBLIC_URL + '/templates/template4.jpeg',
    },
    {
      json: process.env.PUBLIC_URL + '/templates/template5.json',
      preview: process.env.PUBLIC_URL + '/templates/template5.jpeg',
    },
    {
      json: process.env.PUBLIC_URL + '/templates/template6.json',
      preview: process.env.PUBLIC_URL + '/templates/template6.jpeg',
    },
    {
      json: process.env.PUBLIC_URL + '/templates/template7.json',
      preview: process.env.PUBLIC_URL + '/templates/template7.jpeg',
    },
    {
      json: process.env.PUBLIC_URL + '/templates/template8.json',
      preview: process.env.PUBLIC_URL + '/templates/template8.jpeg',
    },
  ];
  return (
    <div style={{ height: '100%', overflow: 'auto', paddingRight: '3px' }}>
      <ImagesGrid
        images={items}
        getPreview={(item) => item.preview}
        onSelect={async (item, pos, element) => {
          const json = await fetch(item.json).then((res) => res.json());
          // if we don't have many pages, just load json directly
          if (store.pages.length <= 1) {
            store.loadJSON(json, true);
          } else {
            // other wise the logic is a bit more complicated
            // first take previous JSON
            const oldJSON = JSON.parse(JSON.stringify(store.toJSON()));
            // not if size of new template is not the same as current store
            // we need to assign sizes of pages manually
            debugger;
            if (
              oldJSON.width !== json.width ||
              oldJSON.height !== json.height
            ) {
              // manually set width from store
              json.pages.forEach((page) => {
                page.width = page.width === 'auto' ? json.width : json.width;
                page.height =
                  page.height === 'auto' ? json.height : json.height;
              });
            }
            // replace ids to make sure there is not duplicates
            json.pages.forEach((page) => {
              page.id = nanoid(10);
              page.children.forEach((child) => {
                child.id = nanoid(10);
              });
            });
            // then find data of active page
            const index = store.pages.indexOf(store.activePage);
            // then replace it in the new JSON
            oldJSON.pages.splice(index, 1, ...json.pages);
            // now we can load the new JSON
            store.loadJSON(oldJSON, true);
          }
        }}
        rowsNumber={1}
        isLoading={!items.length}
        loadMore={false}
      />
    </div>
  );
});

export const TemplatesSection = {
  name: 'templates',
  Tab: (props) => (
    <SectionTab name="Templates" {...props}>
      <img
        src={process.env.PUBLIC_URL + '/icons/templates.svg'}
        alt="Templates"
        style={{ width: '25px' }}
      />
    </SectionTab>
  ),
  Panel: TemplatesPanel,
};
